"use client";

import { useEffect, useRef, useState } from "react";

/**
 * Tracks when an image first loads, for fade-in-on-load. Attach `ref` + `onLoad`
 * to a next/image (or `<img>`); `loaded` flips true on load. The mount-time
 * `complete` check covers a cached image that finished before React attached
 * `onLoad` — without it that image would stay hidden.
 *
 * Use it per-image (fade that image) or as a "cover gate" (attach to one key
 * image, fade a wrapping group on `loaded` so the group fades in once).
 */
export function useImageFade() {
  const ref = useRef<HTMLImageElement>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (ref.current?.complete) setLoaded(true);
  }, []);

  return { loaded, ref, onLoad: () => setLoaded(true) };
}
